/*
 * This is the Component for Adding a NEW Photo, Parent Page is ManagePhotoCollectionPhotos
 */
import React, { useEffect, useState }  from 'react'
import axios                           from 'axios'
import Button                          from '@material-ui/core/Button'
import Grid                            from '@material-ui/core/Grid'
import { CLIENT_PUBLIC_TOKEN }         from '../config'
import { node_server }                 from '../Helpers'
import PropTypes                       from 'prop-types'
import TextareaAutosize                from '@material-ui/core/TextareaAutosize'
import TextField                       from '@material-ui/core/TextField'

import PhotoSearchComponent            from './PhotoSearchComponent'

const EditPhotoInPhotoCollection = ({closeEditPhotoComponent, collectionId, photo}) => {

   const [ description,       setDescription       ]  =  useState('')
   const [ filename,          setFilename          ]  =  useState('')
   const [ height,            setHeight            ]  =  useState(0)
   const [ id,                setId                ]  =  useState('')
   const [ lastNameFirstName, setLastNameFirstName ]  =  useState('')
   const [ showPhotoSearch,   setShowPhotoSearch   ]  =  useState(true)
   const [ width,             setWidth             ]  =  useState(0)

   useEffect( () => {
      setDescription(photo.photoDescription)
      setFilename(photo.photoFilename)
      setHeight(photo.height)
      setId(photo._id)
      setWidth(photo.width)
   }, [photo] )

   const handleAddPhoto = ({ caption, filename }) => {
      setFilename(filename)
      setDescription(caption)
      setShowPhotoSearch(false)
   }

   const descriptionChange = (e) => {
      setDescription(e.target.value)
   }

   const filenameChange = (e) => {
      setFilename(e.target.value)
   }

   const heightChange = (e) => {
      setHeight(Number(e.target.value))
   }

   const square = () => {
      setHeight(1)
      setWidth(1)
   }

   const tall = () => {
      setHeight(4)
      setWidth(3)
   }

   const wide = () => {
      setHeight(3)
      setWidth(4)
   }

   const widthChange = (e) => {
      setWidth(Number(e.target.value))
   }

   const onSubmit = () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.put(node_server + 'photoCollection/UpdatePhoto', {
         description,
         collectionId,
         filename,
         height,
         id,
         lastNameFirstName,
         width
      })
         .then( res => {
            console.log('res is', res)
            if (res.data.msg === 'good operation') {
               closeEditPhotoComponent()
            }
         })
         .catch( (error) => {
            console.error(error)
         })
   }

   return (
      <Grid container style={{marginTop: '2rem'}}>
         {showPhotoSearch
            ?
               <Grid item xs={12} sm={12} >
                  <PhotoSearchComponent buttonLabel={'Select this Photo'} handleAddPhoto={handleAddPhoto} />
               </Grid>
            :
               null
         }
         <Grid container justifyContent='flex-start' item xs={12}>
               <TextField
                  label='Photo Filename, Astronauts userId/filename, Class patch, filename only'
                  name='Photo Filename, Astronauts userId/filename, Class patch, filename only'
                  onChange={filenameChange}
                  variant='outlined'
                  style={{
                     width: '70%', 
                     marginLeft: '10.5rem'
                  }}
                  value={filename}
               />
         </Grid>
         <Grid container justifyContent='flex-start' alignItems='center' item xs={12} style={{marginTop: '1rem'}}>
               <Grid>
                  <TextField label='Width Aspect Ratio' onChange={widthChange} variant='outlined' style={{width: '70%', marginLeft: '10.5rem'}} value={width} />
               </Grid>
               <Grid>
                  <TextField label='Height Aspect Ratio' onChange={heightChange} variant='outlined' style={{width: '70%', marginLeft: '7rem'}} value={height} />
               </Grid>
               <Grid>
                  <Button data-testid='square-aspect-button' onClick={square} variant='contained' style={{marginLeft: '3rem'}}>Square Aspect</Button>
               </Grid>
               <Grid>
                  <Button onClick={tall} variant='contained' style={{marginLeft: '3rem'}}>Tall Aspect</Button>
               </Grid>
               <Grid>
                  <Button onClick={wide} variant='contained' style={{marginLeft: '3rem'}}>Wide Aspect</Button>
               </Grid>
         </Grid>
         <Grid container justifyContent='flex-start' item xs={12} style={{marginTop: '1rem'}}>
               <TextareaAutosize
                  minRows={5}
                  name='Photo Description'
                  onChange={descriptionChange}
                  placeholder='Photo Description'
                  style={{
                     width: '70%',
                     marginLeft: '10.5rem'
                  }}
                  value={description}
                  />
         </Grid>
         <Grid container justifyContent='flex-start' item xs={3} style={{marginTop: '1rem'}}>
            <Button data-testid='add-new-photo-to-collection-button' color='primary' onClick={onSubmit} variant='contained' style={{width: '70%', marginLeft: '10.5rem'}} >
               Update Photo
            </Button>
         </Grid>
      </Grid>
   )
}

EditPhotoInPhotoCollection.propTypes = {
   closeEditPhotoComponent: PropTypes.func,
   collectionId: PropTypes.string,
   photo: PropTypes.object
}

export default EditPhotoInPhotoCollection
